export function roundValue(v, accuracy = 7) {
  return Math.round((v + Number.EPSILON) * 10 ** accuracy) / 10 ** accuracy;
}
